import api from "./api";

// Capa API del canal Telegram (doc 0438, FSD). El token del bot viaja una sola vez, al
// conectar o al reemplazarlo; el backend nunca lo devuelve.
export const getTelegramConfig = () => api.get("/telegram/config");
export const connectTelegramBot = (payload) => api.post("/telegram/connections", payload);
export const getTelegramBot = (whatsAppId) => api.get(`/telegram/connections/${whatsAppId}`);
// Cuenta PERSONAL (doc 0438 Parte V): alta por QR. La contraseña 2FA viaja una vez y no se guarda.
export const createTelegramUserConnection = (payload) => api.post("/telegram-user/connections", payload);
export const getTelegramUserConnection = (whatsAppId) => api.get(`/telegram-user/connections/${whatsAppId}`);
export const sendTelegramUserPassword = (whatsAppId, password) =>
  api.post(`/telegram-user/connections/${whatsAppId}/password`, { password });
export const logoutTelegramUser = (whatsAppId) => api.post(`/telegram-user/connections/${whatsAppId}/logout`);
export const replaceTelegramToken = (whatsAppId, botToken) =>
  api.put(`/telegram/connections/${whatsAppId}/token`, { botToken });
